import { useState } from 'react'

import { AccountSettings } from './AccountSettings'
import { SecuritySettings } from './SecuritySettings'
import { useTabs } from '@/hooks/useTabs'
import NotificationSettings from './NotificationSettings'
import { useLocation } from 'react-router-dom'

export const Settings = () => {
    const tabs = [
        { label: 'Account Settings', id: 'account-settings' },
        // { label: 'Application Preferences', id: 'application-preferences' },
        { label: 'Notification Settings', id: 'notification-settings' },
        { label: 'Security Settings', id: 'security-settings' },
    ]
    const { activeTab, setActiveTab } = useTabs(tabs)

    return (
        <main className="content flex flex-col">
            <div className="px-container flex flex-col flex-auto">
                <div className="settings-row">
                    <aside className="sidebar-settings">
                        <div className="sidebar-settings__sidebar-body">
                            <ul className="menu-list">
                                {tabs.map(el => (
                                    <li
                                        key={el.id}
                                        className="menu-list--item"
                                    >
                                        <button
                                            className={`btn setting-link ${activeTab === el.id ? '--active' : ''}`}
                                            onClick={() => setActiveTab(el.id)}
                                        >
                                            <span className="setting-link-text">
                                                {el.label}
                                            </span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </aside>

                    {activeTab === 'account-settings' && <AccountSettings />}
                    {activeTab === 'security-settings' && <SecuritySettings />}
                    {activeTab === 'notification-settings' && (
                        <NotificationSettings />
                    )}
                </div>
            </div>
        </main>
    )
}
